import React from 'react';
import {BrowserRouter, Route} from 'react-router-dom';

import './../index.css'
import { Contract } from '../pages/contract/Contract';

function Routes() {
    return (
        <BrowserRouter basename="/contract">
            <Route path="/" exact component={Contract} />
        </BrowserRouter>
    )
}

export default Routes;